import { HttpClient } from "@angular/common/http";
import { Injectable, signal } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { ResponseGeneralInterface } from "../../../../../core/interfaces/response/response-general.interface";
import { environment } from "../../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ModalConfirmationDeleteInputCodeService {
  showModal = signal(false);
  private apiUrl = environment.apiUrl
  constructor(private http: HttpClient) { }

  openModal(): void {
    this.showModal.update(() => true);
  }
  closeModal(): void {
    this.showModal.update(() => false);
  }

  deleteAccount(code: string): Observable<ResponseGeneralInterface> {
    return this.http.post<ResponseGeneralInterface>(`${this.apiUrl}/deleteAccount`, { code })
  }
}
